exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-header-wrapper{background-color:#eb4e00}.page-header-wrapper h1{color:#fff;font-size:32px;font-weight:700;text-align:center;letter-spacing:normal;margin-right:auto;margin-left:auto;padding-bottom:16px}@media (min-width:768px){.page-header-wrapper h1{font-size:45px;text-align:left;padding-left:32px;padding-bottom:32px;width:768px}}@media (min-width:992px){.page-header-wrapper h1{font-size:60px;width:992px}}@media (min-width:1200px){.page-header-wrapper h1{width:1200px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/PageHeader/PageHeader.scss
 ** module id = 1205
 ** module chunks = 0
 **/